<template>
    <div>
        <div class="tile tile-secondary">
            <div class="tile-title">
                <h2>Lead Source</h2>
                <r-button type="link" class="no-flex" @click="openLeadSourcesModal">Edit</r-button>
            </div>
            <div class="tile-content">
                <template v-if="hasLeadSources">
                    <template v-if="!hasDifferentOriginal">
                        <table class="table table-definition table-collapsed">
                            <tbody>
                                <tr v-for="key in combinedLeadSources">
                                    <td><span>{{key | unCamelCase | capitalize}}</span></td>
                                    <td>
                                        <span :title="leadSourceString(leadSource, key)" v-fs-block>{{leadSourceString(leadSource, key) | truncate({limit: 15, dots: true})}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <template v-else>
                        <table class="table table-definition">
                            <thead>
                                <th></th>
                                <th>Recent</th>
                                <th>Original</th>
                            </thead>
                            <tbody>
                                <tr><td></td></tr>
                                <tr v-for="key in combinedLeadSources">
                                    <td><span v-fs-block>{{key | unCamelCase | capitalize}}</span></td>
                                    <td>
                                        <span :title="leadSourceString(leadSource, key)" v-fs-block>{{leadSourceString(leadSource, key) | truncate({limit: 15, dots: true})}}</span>
                                    </td>
                                    <td>
                                        <span :title="key" v-fs-block>
                                            {{leadSourceString(leadSource.original, key) | truncate({limit: 15, dots: true})}}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </template>
                <template v-else>
                    <span class="text-muted">There is no lead source associated with this customer</span>
                </template>
            </div>
        </div>
        <lead-sources-modal
            v-if="showModal"
            :entry="leadSource"
            @close="showModal = false"
            @update="updateLeadSourcesInfo"
        />
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';
    import LeadSourceModel from '@/common/models/lead-source-model';
    import LeadSourcesModal from './lead-sources-modal';

    export default {
        name: 'lead-sources',
        components: {vIcon, LeadSourcesModal},
        props: {
            entry: {
                type: Object,
            },
        },
        data() {
            return {
                leadSource: new LeadSourceModel(this.entry.leadSource || {}),
                showModal: false,
            };
        },
        computed: {
            combinedLeadSources() {
                const original = this.leadSource.original
                    ? new LeadSourceModel(this.leadSource.original).editableFields
                    : [];
                const recent = this.leadSource.editableFields;
                const combined = [...recent, ...original];
                return [...new Set(combined)];
            },
            hasLeadSources() {
                return !!this.combinedLeadSources.length;
            },
            hasDifferentOriginal() {
                if (this.leadSource.original) {
                    return !!this.combinedLeadSources
                        .find(key => this.leadSource[key] !== this.leadSource.original[key]);
                }
                return false;
            },
        },
        methods: {
            leadSourceString(leadSource, key) {
                if (!leadSource[key]) {
                    return this.$emptyInnerHTML();
                }
                if (key === 'amount') {
                    return this.$filters.number(leadSource[key], {minimumFractionDigits: 2});
                }
                return leadSource[key];
            },
            openLeadSourcesModal() {
                this.showModal = true;
            },
            async updateLeadSourcesInfo(leadSource) {
                const params = {
                    id: this.entry.id,
                    data: leadSource.getPayload(),
                };
                this.$startLoading('lead-sources');
                try {
                    const {fields} = await this.$api(({customers}) => customers.updateLeadSource(params));
                    this.leadSource = new LeadSourceModel(fields);
                    this.$stopLoading('lead-sources');
                    this.$emit('updated');
                    this.$toast.positive('Lead sources successfully updated');
                } catch (error) {
                    this.$stopLoading('lead-sources');
                    this.$toast.fromError(error);
                }
            },
        },
    };
</script>
